export default {
  equip: '选择设备',
  name1: '真实姓名',
  name2: '请输入真实姓名',
  address1: '录音对象国籍',
  address2: '请输入录音对象国籍',
  language1: '选择语言',
  language2: '请选择',
  upload1: '上传音频',
  upload2: '将文件拖到此处，或',
  upload3: '点击上传',
  upload4: '只能上传一个wav格式的音频文件，且不超过500Mb',
  submit: '提交',
  reset: '重置',
  js: {
    rules: {
      equip: '设备不能为空',
      name: '真实姓名不能为空',
      address: '录音对象国籍不能为空',
      language: '必须选择语言'
    },
    error: {
      type1: '失败',
      type2: '还没有上传文件',
      type3: '文件太大',
      type4: '上传失败，请刷新重试！',
      type5: '确定移除'
    },
    success: {
      type1: '成功',
      type2: '上传成功'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/collectWav.js